interface DownloadFileProps {
  name: string;
  url: string;
}

export const downloadFile = ({ url, name }: DownloadFileProps) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
